import { ISelectOption } from 'Frontend/scripts/models/forums.model'
import { Form } from 'react-bootstrap'
import { FunctionComponent, useEffect, useState } from 'react'
import Select, { MultiValue } from 'react-select'
import { NewsListFilterProps } from 'Frontend/types/types'
import useQueryParams from 'Frontend/hooks/useQueryParams'
import { useTranslation } from 'react-i18next'

const NewsListFilter: FunctionComponent<NewsListFilterProps> = ({ callback, options }) => {
  const [defaultSelectedOptions, setDefaultSelectedOptions] = useState<ISelectOption[] | null>(null)
  const { setQueryParam, getQueryParam, removeQueryParam } = useQueryParams()
  const { t } = useTranslation()

  useEffect(() => {
    if (options?.length === 0) return
    if (getQueryParam('filters')?.length === 0) return

    const valuesString = getQueryParam('filters')
    const valuesArray = valuesString?.split(',').map(String)
    const subset = options?.filter((option) => valuesArray?.includes(option.value.toString()))

    setDefaultSelectedOptions(subset as ISelectOption[])
  }, [options, getQueryParam('filters')])

  const onChange = (selected: MultiValue<ISelectOption>) => {
    let filterArrary: string[] = []

    selected.map((option) => {
      filterArrary.push(option.value.toString())
    })
    if (filterArrary.length) {
      setQueryParam('filters', filterArrary.toString())
    } else {
      removeQueryParam('filters')
    }

    if (callback) {
      callback(selected)
    }
  }

  if (defaultSelectedOptions === null) return <></>

  return (
    <div className="newslist__filter mb-4">
      <h3 className="fw-semibold mb-2">{t('filter-options')}</h3>
      <Form.Group>
        <Form.Label htmlFor="react-select-newslist-filter-input">{t('category')}</Form.Label>
        <Select
          instanceId="newslist-filter"
          options={options}
          isMulti
          defaultValue={defaultSelectedOptions}
          classNamePrefix="newslist"
          onChange={(selected: MultiValue<ISelectOption>) => onChange(selected)}
          placeholder={<div className="multi-select__placeholder">{t('news.filter-on-category')}</div>}
        ></Select>
      </Form.Group>
    </div>
  )
}

export default NewsListFilter
